import React from 'react';
import PropTypes from 'prop-types';
import { useEntitiesFulfillmentPlan } from '../../../hooks/entities/selectors/fulfillment-plans';

import { useSellerFormattedDate } from '../../../hooks/use-datetime-formats';
import { messages } from './messages';

const ShipByColumn = ({ fulfillmentPlanId }) => {
  const { fulfillmentPlanDates } = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const shipByInUserTimeZoneAndFormat = useSellerFormattedDate(fulfillmentPlanDates.shipByDate);

  if (!fulfillmentPlanDates.shipByDate) {
    return '';
  }

  return shipByInUserTimeZoneAndFormat;
};

ShipByColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const ShipBy = {
  getMessageDescriptor: () => messages.shipBy,
  id: 'ship-by',

  render: (data) => {
    return <ShipByColumn fulfillmentPlanId={data.id} />;
  },
};
